import { render, staticRenderFns } from "./color-selector.vue?vue&type=template&id=42de2bdd"
import script from "./color-selector.vue?vue&type=script&lang=ts"
export * from "./color-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports